import { render, staticRenderFns } from "./AdministrationStage.vue?vue&type=template&id=c06d803e"
import script from "./AdministrationStage.vue?vue&type=script&lang=js"
export * from "./AdministrationStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports